import {gql} from 'graphql-request';
import {useMutation} from '@tanstack/react-query';
import userStateGraphQLClient from '../services/UserStateApi/graphqlClient';

const useSetRegistryInterests = () =>
  useMutation(async ({interestIds}) =>
    userStateGraphQLClient.request(
      gql`
        mutation setInterests($interestIds: [Int!]!) {
          setInterests(interestIds: $interestIds) {
            success
            message
            user {
              memberId
              interests {
                interestIds
              }
            }
          }
        }
      `,
      {
        interestIds,
      },
    ),
  );

export default useSetRegistryInterests;
